module.exports = __webpack_public_path__ + "img/casa-techo-sin-fondo.f5969896.png";